import React from 'react';
import { NotFoundFeature } from '@Src/features/NotFound/NotFound';

export const NotFound = () => {
    return (
        <NotFoundFeature />
    );
};
